import { render, staticRenderFns } from "./exc.vue?vue&type=template&id=1ea85e5a&scoped=true&"
import script from "./exc.vue?vue&type=script&lang=js&"
export * from "./exc.vue?vue&type=script&lang=js&"
import style0 from "./exc.vue?vue&type=style&index=0&id=1ea85e5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ea85e5a",
  null
  
)

export default component.exports